export default "__VITE_PUBLIC_ASSET__44115df4__"